export default __webpack_public_path__ + "static/pbs-2e5689da5a1eee8e18f8ccda2b28d306.png";